export const ASSET_IMG_PLACEHOLDER = 'https://yaathrikan.com/assets/web/img/image_placeHolder.png';